// @flow
import * as React from 'react';
import styled from 'styled-components';
import * as ss from 'styled-system';
import { getClassName } from '../theme';

const BaseBox = styled(
  ({
    dispatch,
    position,
    top,
    right,
    bottom,
    left,
    zIndex,
    transform,
    m,
    mr,
    ml,
    mt,
    mb,
    mx,
    my,
    p,
    pr,
    pl,
    pt,
    pb,
    px,
    py,
    display,
    width,
    height,
    maxWidth,
    maxHeight,
    minWidth,
    minHeight,
    flex,
    order,
    alignSelf,
    justifySelf,
    alignItems,
    alignContent,
    justifyContent,
    flexWrap,
    flexBasis,
    flexDirection,
    columnStart,
    columnEnd,
    overflow,
    color,
    opacity,
    visibility,
    bg,
    backgroundImage,
    backgroundSize,
    backgroundPosition,
    backgroundRepeat,
    backgroundColor,
    borderBottom,
    borderTop,
    borderLeft,
    borderRight,
    border,
    borderColor,
    borderWidth,
    borderStyle,
    borderRadius,
    boxShadow,
    fontSize,
    fontFamily,
    lineHeight,
    fontWeight,
    letterSpacing,
    textAlign,
    verticalAlign,
    textOverflow,
    textTransform,
    textDecoration,
    whiteSpace,
    wordBreak,
    transition,
    willChange,
    pointerEvents,
    component,
    classes,
    className,
    printHidden,
    ...props
  }: {
    component?: React.ElementType,
    classes?: Array<UtilityClass>,
    className: string,
    printHidden?: boolean
  }) => {
    const BoxComponent = component || 'div';
    return (
      <BoxComponent {...props} className={getClassName(className, classes)} />
    );
  }
).attrs(
  ({
    transition,
    zIndex,
    overflow,
    justifySelf,
    alignSelf,
    alignContent,
    filter,
    opacity,
    background,
    backgroundImage,
    backgroundRepeat,
    backgroundColor,
    backgroundPosition,
    backgroundSize,
    textOverflow,
    textTransform,
    textDecoration,
    whiteSpace,
    willChange,
    wordBreak,
    visibility,
    verticalAlign,
    pointerEvents,
    letterSpacing,
    lineHeight
  }) => ({
    style: {
      transition,
      zIndex,
      overflow,
      justifySelf,
      alignSelf,
      alignContent,
      filter,
      opacity,
      background,
      backgroundImage,
      backgroundRepeat,
      backgroundColor,
      backgroundPosition,
      backgroundSize,
      textOverflow,
      textTransform,
      textDecoration,
      whiteSpace,
      willChange,
      wordBreak,
      visibility,
      verticalAlign,
      pointerEvents,
      letterSpacing,
      lineHeight
    }
  })
)`
  ${ss.position} 
  ${ss.top} 
  ${ss.right} 
  ${ss.bottom}
  ${ss.left}
  ${ss.space} 
  ${ss.display}
  ${ss.width} 
  ${ss.height} 
  ${ss.maxWidth} 
  ${ss.maxHeight} 
  ${ss.minWidth} 
  ${ss.minHeight} 
  ${ss.flex} 
  ${ss.order} 
  ${ss.alignItems} 
  ${ss.justifyContent} 
  ${ss.flexWrap} 
  ${ss.flexDirection} 
  ${ss.color} 
  ${ss.borders}
  ${ss.borderRadius} 
  ${ss.boxShadow} 
  ${ss.fontSize} 
  ${ss.fontWeight} 
  ${ss.textAlign}
  ${ss.system({
    transform: true
  })}
  ${props =>
    props.printHidden &&
    `
    @media print {
      display: none !important;
    }
  `}
`;

const Box = ({
  classes,
  component,
  ...props
}: {
  classes?: Array<UtilityClass>,
  component?: React.ElementType
}) => <BaseBox classes={classes} component={component} {...props} />;

export default Box;
